export const PROTICSMX = 'PROTICSMX';
